import { useAuth } from "@/context/AuthContext";
import { Navigate, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { rememberIntent } from "@/lib/authRedirect";

export default function ProtectedRoute({ children, role }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading || user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <Loader2 className="h-8 w-8 animate-spin text-accent" />
      </div>
    );
  }
  if (!user) {
    rememberIntent({ dest: location.pathname + location.search });
    return <Navigate to="/login" replace />;
  }

  if (role) {
    const allowed = role === "admin"
      ? ["admin", "super_admin"].includes(user.role)
      : user.role === role || user.role === "super_admin";
    if (!allowed) return <Navigate to="/" replace />;
  }
  return children;
}
